module.exports = __webpack_public_path__ + "img/small-5.7c00c429.webp";